import { getFetchWrapper } from "@syf-api-library/core";
import { autoRegisterUrl } from "../endpoints.js";
const mutationFnFactory = (config, headers = {}) => {
  return (variables) => {
    const fetchWrapper = getFetchWrapper(config);
    return fetchWrapper(autoRegisterUrl, {
      method: "POST",
      body: JSON.stringify(variables),
      headers
    });
  };
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
